import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {InhouseListModel} from '../views/models/inhouse-list.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InhouseListService {

  inHouseList$: BehaviorSubject<InhouseListModel[]> = new BehaviorSubject<InhouseListModel[]>([]);

  constructor(private http: HttpClient) {
  }

  getList() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.baseURL + '/v2/api/guest_list').subscribe((resp: InhouseListModel[]) => {
        this.inHouseList$.next(resp);
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  postList(file: File) {
    return new Promise((resolve, reject) => {
      const FORMDATA = new FormData();
      FORMDATA.append('file', file);
      this.http.post(environment.baseURL + '/v2/api/import_guest_list', FORMDATA).subscribe(resp => {
        this.getList();
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  deleteItem(id: number) {
    this.http.delete(environment.baseURL + '/v2/api/guest_list/' + id).subscribe(resp => {
      this.getList();
    }, err => {
      console.log(err);
    });
  }

  postGuest(data: InhouseListModel) {
    this.http.post(environment.baseURL + '/v2/api/guest_list', data).subscribe(resp => {
      this.getList();
    }, err => {
      console.log(err);
    });
  }

  putItem(data: InhouseListModel) {
    this.http.put(environment.baseURL + '/v2/api/guest_list/' + data.id, data).subscribe(resp => {
      this.getList();
    }, err => {
      console.log(err);
    });
  }
}
